
import { Component, Mixins } from 'vue-property-decorator';
import Page from '@/views/Page.vue';
import { VuetifyMixin, BAIconsMixin, FormRulesMixin, StatusMixin, SportsMixin } from '@/mixins';
import { AthleteReportCategoryHeading } from "@/models"
import { SportLabel, SportModel } from "@/models/sport";
import { sportStore } from '@/store'
import { DataTableHeader } from 'vuetify';
import FileUploadArea from '@/components/forms/FileUploadArea.vue';
import { BodyPart, BodyPartValues, SportNameValues } from "@/../types/enums";
import { cloneDeep } from 'lodash';
import TooltipButton from '@/components/ui/TooltipButton.vue';

@Component({
	components: {
		Page,
        FileUploadArea,
	}
})
export default class SportAdminDashboard extends Mixins(VuetifyMixin, SportsMixin, BAIconsMixin, FormRulesMixin, StatusMixin){
    search = "";
    
    get SportNames(): string[] {
        return SportNameValues;
    }
    get BodyPartNames(): string[] {
        return BodyPartValues;
    }
    get IsLoading(): boolean {
        return this.isSportsLoading;
    }

    get Headers(): DataTableHeader<any>[] {
        return [
            {text: 'Icon', value: 'icon', sortable: false},
            {text: 'Name', value: 'name'},
            {text: 'Active', value: 'active', align: 'center', sortable: false},
            {text: 'Pro Search', value: 'proSearch', align: 'center', sortable: false},
            {text: 'Athlete Reports', value: 'athleteReports', align: 'center', sortable: false},
            {text: 'Physical Assessments', value: 'physical', align: 'center', sortable: false},
            {text: 'Scouting Reports', value: 'scouting', align: 'center', sortable: false},
            {text: '', width:"50", value: 'actions', sortable: false},
            {text: '', width:"25", value: 'data-table-expand'}
        ]
    }
    get AthleteReportTableHeaders(): DataTableHeader<any>[] {
        return [
            {text: 'Heading', value:'name', sortable: false, align: 'start', width:'100' },
            {text: 'Categories', value:'categories', align: 'start', sortable: false },
            {text: '', value:'actions', sortable: false, align: 'end', width:'25' },
        ]
    }

    async onClickActive(sport: SportModel) {
        sport.active = !sport.active;
        await sportStore.saveSport(sport);
    }
    async onClickProSearch(sport: SportModel) {
        sport.proSearch = !sport.proSearch;
        await sportStore.saveSport(sport);
    }


    setFocus(field: any) {
        field.focus();
    }
    newPosition: string = '';
    onAddPosition() {
        this.editSport.positions.push(this.newPosition);
        this.newPosition = '';
        this.setFocus(this.$refs.position);
    }
    onRemoveAllPositions() {
        this.editSport.positions = [];
        this.setFocus(this.$refs.position);
    }

    newAthleteReportHeading: string = '';
    onAddAthleteReportHeading() {
        const heading: AthleteReportCategoryHeading = new AthleteReportCategoryHeading(this.newAthleteReportHeading);
        this.newAthleteReportHeading = '';
        this.setFocus(this.$refs.athletereportHeading);
        this.editSport.athleteReportHeadings.push(heading);
    }
    onRemoveAllAthleteReportHeadings() {
        this.editSport.athleteReportHeadings = [];
        this.setFocus(this.$refs.athletereportHeading);
    }

    physicalAssessmentLabel: SportLabel;
    isEditingPhysicalAssessmentLabel: boolean = false;
    isAddingPhysicalAssessmentLabel: boolean = false;
    isPhysicalAssessmentLabelChanging: boolean = false;
    onAddPhysicalAssessmentLabelBegin() {
        this.physicalAssessmentLabel = new SportLabel;
        this.onAddPhysicalAssessmentLabelChange();
        this.isEditingPhysicalAssessmentLabel = false;
        this.isAddingPhysicalAssessmentLabel = true;
    }
    onAddPhysicalAssessmentLabelChange() {
        this.isPhysicalAssessmentLabelChanging = true;
        this.isPhysicalAssessmentLabelChanging = false;
    }
    onPhysicalAssessmentLabelFormCancel() {
        this.isEditingPhysicalAssessmentLabel = false;
        this.isAddingPhysicalAssessmentLabel = false;
        this.physicalAssessmentLabel = undefined;
    }
    onPhysicalAssessmentLabelFormConfirm() {
        if( this.IsEmpty(this.physicalAssessmentLabel?.label) ) {
            this.setFocus(this.$refs.physicalAssessmentLabel);
            return;
        }
        if( this.isAddingPhysicalAssessmentLabel ) this.editSport.physicalAssessmentLabels.push(this.physicalAssessmentLabel);
        this.isEditingPhysicalAssessmentLabel = false;
        this.isAddingPhysicalAssessmentLabel = false;
        this.physicalAssessmentLabel = undefined;
    }
    onEditPhysicalAssessmentLabelBegin(label: SportLabel) {
        this.physicalAssessmentLabel = label;
        this.onAddPhysicalAssessmentLabelChange();
        this.isAddingPhysicalAssessmentLabel = false;
        this.isEditingPhysicalAssessmentLabel = true;
    }
    onRemoveAllPhysicalAssessmentLabels() {
        this.editSport.physicalAssessmentLabels = [];
        this.setFocus(this.$refs.physicalAssessmentLabel);
    }
    newBodyPart: BodyPart = BodyPart.Unknown;
    onAddBodyPart() {
        this.editSport.bodyParts.push(this.newBodyPart);
        this.newBodyPart = BodyPart.Unknown;
        this.setFocus(this.$refs.bodyParts)
    }
    onRemoveAllBodyParts() {
        this.editSport.bodyParts = [];
        this.setFocus(this.$refs.bodyParts)
    }
    newScoutingLabel: string = '';
    onAddScoutingLabel() {
        this.editSport.scoutingLabels.push(this.newScoutingLabel);
        this.newScoutingLabel = '';
        this.setFocus(this.$refs.scoutingLabel);
    }
    onRemoveAllScoutingLabels() {
        this.editSport.scoutingLabels = [];
        this.setFocus(this.$refs.scoutingLabel);
    }
    newScoutingMoment: string = '';
    onAddScoutingMoment() {
        this.editSport.scoutingMoments.push(this.newScoutingMoment);
        this.newScoutingMoment = '';
        this.setFocus(this.$refs.scoutingMoment);
    }
    onRemoveAllScoutingMoments() {
        this.editSport.scoutingMoments = [];
        this.setFocus(this.$refs.scoutingMoment);
    }
    newScoutingEvaluation: string = '';
    onAddScoutingEvaluation() {
        this.editSport.scoutingEvaluations.push(this.newScoutingEvaluation);
        this.newScoutingEvaluation = '';
        this.setFocus(this.$refs.scoutingEvaluation);
    }
    onRemoveAllScoutingEvaluations() {
        this.editSport.scoutingEvaluations = [];
        this.setFocus(this.$refs.scoutingEvaluation);
    }

    editTitle: string = "Edit Sport";
    backupSport: SportModel;
    editSport: SportModel = new SportModel;
    validSport: boolean;
    editingSport: boolean = false;
    onAddSport() {
        this.editTitle = "Add Sport";
        this.editSport = new SportModel();
        this.editingSport = true;
    }
    onEditSport(sport: SportModel) {
        this.editTitle = `Edit ${sport.name}`;
        this.backupSport = cloneDeep(sport);
        this.editSport = sport;
        this.editingSport = true;
    }
    async onDeleteSport(sport: SportModel) {
        if( !confirm(`Delete ${sport.name}? This action cannot be undone`) ) return;

        await sportStore.deleteSport(sport);
        // this.loadAllSports(); CCM_RESTORE
    }
    onCancelEditDlg() {
        if( this.IsNotEmpty(this.backupSport) ) this.editSport.load(this.backupSport);
        this.backupSport = undefined;
        this.editingSport = false;
    }
    async onSaveEditDlg() {
        if( !(this.$refs.form as HTMLFormElement).validate() ) {
            this.setError( "Please complete all of the required fields" );
            return;
        }
        
        await sportStore.saveSport(this.editSport);
        // await this.loadAllSports(); CCM_RESTORE
        this.editingSport = false;
    }
}
